/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData, FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataFromJSONTyped, FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataToJSON, } from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData';
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData(json)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData(value)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLogin.js.map